import { IShellState } from '../../types/store';

const initialState = { build: process.env.REACT_APP_BUILD_ID, commit: process.env.REACT_APP_COMMIT_SHA };

const reducer = (): IShellState => initialState;

export default reducer;
